module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("macOS操作系统安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、macOS操作系统版本要求")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#CCFFFF",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('span', [_c('p', [_vm._v("macOS操作系统版本 > 10.11")])])]), _vm._v(" "), _c('span', [_vm._v("查看macOS操作系统版本：")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic01.png"),
      "width": "740px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、MAC版MOA下载")]), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "10",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("下载地址")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://itportal.sankuai.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n        https://itportal.sankuai.com/")]), _vm._v("（移步IT门户）")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、MOA安装流程")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、双击打开安装包")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic02.png"),
      "width": "540px",
      "height": "160px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、一路“继续”，直到需要输入本地管理员密码授权安装，请您输入正确的本地管理员密码。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic03.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic04.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic05.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic06.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic07.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、安装成功后会跳出扫码登陆界面，如果未跳出该界面，请在“应用程序”中找到MOA客户端，点击打开。使用大象扫码登陆或选择输入账号密码登陆。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic08.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫码登陆成功后会跳出“协议签署”，请仔细阅读“安全管理客户端用户协议”后，然后选择“同意”。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic09.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("4、安装完成确认")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、客户端在线确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic10.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、安装版本确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic11.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、绑定MOA账号确认")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic12.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("5、安装异常解决")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v("5.1 打不开MOA安装包，因为它来自身份不明的开发者。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("安装时报错如图：“打不开“办公软件_企业内部软件_MOA_MOA-1.2.2.10-release.pkg”，因为它来自身份不明的开发者。“")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic13.png"),
      "width": "640px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("解决方法：在“系统偏好设置“-->”“安全性与隐私”-->\"通用\" 中找到阻止MOA打开的选项， 选择“仍然打开”。")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic14.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic15.png"),
      "width": "540px",
      "height": "360px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/moaInstallForMac/moaInstallForMac_pic16.png"),
      "width": "440px",
      "height": "300px"
    }
  }), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-319afa27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/moaInstallForMac.vue
// module id = 636
// module chunks = 1